import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PAD_KEYS = ["7", "8", "9", "4", "5", "6", "1", "2", "3", ".", "0", "⌫"];
/**
 * §5's explicit touch-based numeric pad, "integrated directly into the UI layer to
 * bypass volatile mobile soft-keyboards" — a mobile browser's virtual keyboard resizes
 * the viewport unpredictably and offers no way to constrain input to digits-only across
 * every device, which is untenable at a till. Every key is sized to
 * `FIXED_TOKENS.touchTargetMin` via the `sl-numeric-pad__key` class (see `styles.css`).
 */
export function NumericPad({ value, onChange, onSubmit, submitLabel = "Enter", allowDecimal = true, maxLength, disabled = false, }) {
    function pressKey(key) {
        if (disabled)
            return;
        if (key === "⌫") {
            onChange(value.slice(0, -1));
            return;
        }
        if (key === ".") {
            if (!allowDecimal || value.includes("."))
                return;
            onChange(value.length === 0 ? "0." : value + ".");
            return;
        }
        // Digit key.
        if (maxLength !== undefined && value.length >= maxLength)
            return;
        // Avoid an unbounded run of leading zeros (e.g. "007") while still allowing "0.5".
        const next = value === "0" ? key : value + key;
        onChange(next);
    }
    return (_jsxs("div", { className: "sl-numeric-pad", role: "group", "aria-label": "Numeric keypad", children: [_jsx("output", { className: "sl-numeric-pad__display", "aria-live": "polite", children: value.length > 0 ? value : "0" }), _jsx("div", { className: "sl-numeric-pad__grid", children: PAD_KEYS.map((key) => (_jsx("button", { type: "button", className: "sl-numeric-pad__key", disabled: disabled || (key === "." && !allowDecimal), onClick: () => pressKey(key), "aria-label": key === "⌫" ? "Backspace" : key === "." ? "Decimal point" : key, children: key }, key))) }), _jsxs("div", { className: "sl-numeric-pad__actions", children: [_jsx("button", { type: "button", className: "sl-numeric-pad__key sl-numeric-pad__key--clear", disabled: disabled, onClick: () => onChange(""), children: "Clear" }), onSubmit ? (_jsx("button", { type: "button", className: "sl-numeric-pad__key sl-numeric-pad__key--submit", disabled: disabled, onClick: onSubmit, children: submitLabel })) : null] })] }));
}
//# sourceMappingURL=NumericPad.js.map